import React from 'react';
import CreateTagStationModal from '../../shared/component/tag/CreateTagStationModal';
import CreateTagStationModalMobile from '../../shared/component/tag/mobile/CreateTagStationModalMobile';
import { useGroupMemberTag } from '../../shared/hooks/useApi/useGroupMemberTag';

interface CreateGroupMemberTagModalProps {
  isMobile: boolean;
  setIsUserInput: (isUserInput: boolean) => void;
}

const CreateGroupMemberTagModal: React.FC<CreateGroupMemberTagModalProps> = ({
  isMobile,
  setIsUserInput,
}) => {
  const { createGroupMemberTag } = useGroupMemberTag();
  const modalProps = {
    createTag: createGroupMemberTag,
    setIsUserInput,
  };

  return isMobile
    ? <CreateTagStationModalMobile {...modalProps} />
    : <CreateTagStationModal {...modalProps} />;
};

export default CreateGroupMemberTagModal;
